import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import useFetch from "../hooks/useFetch";
import "./Reserve.css";
import { useNavigate } from "react-router-dom";

import { useState } from "react";
import { useContext } from "react";
import { SearchContext } from "../context/SearchContext";
import axios from "axios";
export default function Reserve({ setOpen, hotelId }) {
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [message, setMessage] = useState(false);
  const { data, load, error } = useFetch(`https://booking-app-node.herokuapp.com/api/hotels/room/${hotelId}`);
  const { dates } = useContext(SearchContext);


  const getDatesInRange = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const date = new Date(start.getTime());

    const dates = [];

    while (date <= end) {
      dates.push(new Date(date).getTime());
      date.setDate(date.getDate() + 1);
    }

    return dates;
  };

  const alldates = getDatesInRange(dates[0]?.startDate, dates[0]?.endDate);

  const isAvailable = (roomNumber) => {
    const isFound = roomNumber.unavailableDates.some((date) =>
      alldates.includes(new Date(date).getTime())
    );

    return !isFound;
  };

  const handleSelect = (e) => {
    const checked = e.target.checked;
    const value = e.target.value;
    setSelectedRooms(
      checked
        ? [...selectedRooms, value]
        : selectedRooms.filter((item) => item !== value)
    );
  };

  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      console.log("datas are added");
      await Promise.all(

        selectedRooms.map((roomId) => {
          const res = axios.put(`https://booking-app-node.herokuapp.com/api/rooms/availability/${roomId}`, {
          
          
            dates: alldates,
         
          });
          setMessage(true);
         
          return res.data;
        })
      );
      setOpen(false);

   
    
      
    } catch (err) {}
  };
  return (
    <div className="reserve">
      <div className="reserveContainer">
        <FontAwesomeIcon
          icon={faCircleXmark}
          className="rClose"
          onClick={() => setOpen(false)}
        />
        <span>Select your rooms:</span>
        {data.map((item) => (
          <div className="resultItem" key={item._id}>
            <div className="resultItemInfo">
              {/* <div className="resultTitle">{item.title}</div> */}
              <div className="resultDesc">{item.desc}</div>
              <div className="resultMax">
                Max people: <b>{item.maxPeople}</b>
              </div>
              <div className="resultPrice">{item.price}</div>
            </div>
            <div className="rSelectRooms">
              {item.roomNumbers.map((roomNumber) => (
                <div className="room">
                  <label>{roomNumber.number}</label>
                  <input
                    type="checkbox"
                    value={roomNumber._id}
                    onChange={handleSelect}
                    disabled={!isAvailable(roomNumber)}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
        <button onClick={handleClick} className="rButton">
          Reserve Now!
        </button>

        {message && (
            <span
              style={{ color: "green", textAlign: "center", marginTop: "20px" }}
            >
             room reserved...
            </span>
          )}
      </div>
    </div>
  );
};

